import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AboutusComponent, PrivacyPolicyComponent, TermsOfServiceComponent } from './core/components';
import {
    EditMyProfileComponent,
    OrderSuccessComponent,
    PaymentComponent,
    PublicProfileComponent,
    ReviewFormMobileComponent
} from './feature/components';
import { AdminDashboardComponent } from './feature/components/admin-dashboard/admin-dashboard.component';
import { AllReviewsMobileComponent } from './feature/components/product-details-mobile/all-reviews-mobile/all-reviews-mobile.component';
import {
    CartComponent,
    CategoriesComponent,
    ForgotPasswordComponent,
    LandingComponent,
    ProductsComponent,
    ResetPasswordComponent,
    SearchComponent,
} from './feature/containers';
import { MailListingComponent } from './feature/containers/mail-listing/mail-listing.component';
import { ProductCollectionsComponent } from './feature/containers/product-collections/product-collections.component';
import { ProductKeywordMappingComponent } from './feature/containers/product-keyword-mapping/product-keyword-mapping.component';
import { QuizDesktopComponent } from './quiz/quiz-desktop/quiz-desktop.component';
import { ResultPageComponent } from './quiz/result-page/result-page.component';
import { AdminGuard } from './shared/services/admin/admin.guard';
import { SellerGuard } from './shared/services/seller/seller.guard';

import { DesignDashboardComponent } from './feature/containers/design-dashboard/design-dashboard.component';
import { ShopComponent } from './feature/containers/landing/shop/shop.component';
import { OnboardQuizDesktopComponent } from './quiz/onboard-quiz-desktop/onboard-quiz-desktop.component';

import { BookingPaypalComponent } from './core/components/booking-paypal/booking-paypal.component';
import { AllRoomsComponent } from './feature/components/all-rooms/all-rooms.component';
import { CompareComponent } from './feature/components/compare/compare.component';
import { FavoritesComponent } from './feature/components/favorites/favorites.component';
import { ProductCatalogComponent } from './feature/components/product-catalog/product-catalog.component';
import { ProductRestrictedComponent } from './feature/components/product-restricted/product-restricted.component';
import { ThankYouComponent } from './feature/components/thank-you/thank-you.component';
import { ViewProjectIntakeFormComponent } from './feature/components/view-project-intake-form/view-project-intake-form.component';
import { AdminAddProductComponent } from './feature/containers/admin-add-product/admin-add-product.component';
import { CbInventoryComponent } from './feature/containers/cb-inventory/cb-inventory.component';
import { PartnersComponent } from './feature/containers/partners/partners.component';
import { DesignSignUpComponent } from './quiz/design-sign-up/design-sign-up.component';
import { ProjectDetailsComponent } from './quiz/project-details/project-details.component';
import { DesignContactLogComponent } from './feature/containers/design-contact-log/design-contact-log.component';
import { CustomerFavoritesComponent } from './feature/components/customer-favorites/customer-favorites.component';

const routes: Routes = [
    { path: '', component: LandingComponent, pathMatch: 'full' },
    { path: 'shop', component: ShopComponent },
    {
        path: environment.BOARD_BASE_HREF,
        loadChildren: () =>
            import('./modules/board/board.module').then((m) => m.BoardModule),
        // pathMatch: 'full'
    },

    { path: 'search', component: SearchComponent },
    {
        path: 'chat',
        loadChildren: () =>
            import('./chat/chat.module').then((m) => m.ChatModule),
    },
    {
        path: 'c/:id',
        loadChildren: () =>
            import('./chat/chat.module').then((m) => m.ChatModule),
    },
    {
        path: 'c',
        loadChildren: () =>
            import('./chat/chat.module').then((m) => m.ChatModule),
    },
    { path: 'aboutus', component: AboutusComponent },
    { path: 'termsofservice', component: TermsOfServiceComponent },
    { path: 'privacypolicy', component: PrivacyPolicyComponent },
    { path: 'cart', component: CartComponent },

    { path: 'design/book/payment', component: BookingPaypalComponent },
    { path: 'design/book/sign-up', component: DesignSignUpComponent },
    { path: 'design/rooms', component: AllRoomsComponent },
    { path: 'design/compare-havenly', component: CompareComponent },

    {
        path: 'admin/dashboard/design/rooms/:id/profile', component: ViewProjectIntakeFormComponent,
        canActivate: [AdminGuard]
    },
    {
        path: 'admin/dashboard/design/rooms/:id/files', component: ViewProjectIntakeFormComponent,
        canActivate: [AdminGuard]
    },
    {
        path: 'admin/dashboard/design/rooms/:id/designs', component: ViewProjectIntakeFormComponent,
        canActivate: [AdminGuard]
    },
    {
        path: 'admin/dashboard/design/rooms/:id/shopping-list', component: ViewProjectIntakeFormComponent,
        canActivate: [AdminGuard]
    },
    {
        path: 'admin/dashboard/design/rooms/:id/pinterest', component: ViewProjectIntakeFormComponent,
        canActivate: [AdminGuard]
    },
    {
        path: 'admin/dashboard/design/rooms/:id/contact-log', component: ViewProjectIntakeFormComponent,
        canActivate: [AdminGuard]
    },
    {
        path: 'admin/dashboard/design/rooms/:id/design-history', component: ViewProjectIntakeFormComponent,
        canActivate: [AdminGuard]
    },
     {
        path: 'admin/dashboard/design/rooms/:id/specs', component: ViewProjectIntakeFormComponent,
        canActivate: [AdminGuard]
    },
    {
        path: 'admin/dashboard/design/rooms/:id/notes', component: ViewProjectIntakeFormComponent,
        canActivate: [AdminGuard]
    },

    { path: 'design/book/project-details/:bookingId', component: ProjectDetailsComponent },

    { path: 'design/rooms/landing', component: ThankYouComponent },
    {
        path: 'design/rooms/:id/designs', loadChildren: () =>
            import('./modules/project-designs/project-designs.module').then((m) => m.ProjectDesignsModule),

    },
     {
        path: 'design/rooms/:id/boards', loadChildren: () =>
            import('./modules/project-designs/project-designs.module').then((m) => m.ProjectDesignsModule),

    },
      {
        path: 'design/rooms/:id/specs', loadChildren: () =>
            import('./modules/project-designs/project-designs.module').then((m) => m.ProjectDesignsModule),

    },
    {
        path: 'design/rooms/:id/shopping-list', loadChildren: () =>
            import('./modules/project-designs/project-designs.module').then((m) => m.ProjectDesignsModule),

    },


    // { path: 'brands', component: BrandsComponent },
    {
        path: 'design',
        loadChildren: () =>
            import('./design/design.module').then((m) => m.DesignModule),
    },
    {
        path: 'room-profile/:roomId',
        loadChildren: () =>
            import('./room-profile/room-profile.module').then((m) => m.RoomProfileModule),
    },
    { path: 'checkout', component: PaymentComponent },
    { path: 'order/:order', component: OrderSuccessComponent },
    // {
    //     path: 'products/all',
    //     component: AllProductsComponent,
    //     pathMatch: 'full',
    // },
    // {
    //     path: 'brand/:brandName',
    //     component: AllProductsComponent,

    // },
    {
        path: 'products/collections',
        component: ProductCollectionsComponent,
        pathMatch: 'full',
    },
    // {
    //     path: 'product/contact',
    //     component: NoProductFoundComponent
    // },
    {
        path: 'product/:id/r',
        component: ProductRestrictedComponent
    },
    {
        path: 'products/new',
        component: ProductKeywordMappingComponent,
        pathMatch: 'full',
    },
    {
        path: 'products/sale',
        component: ProductKeywordMappingComponent,
        pathMatch: 'full',
    },
    {
        path: 'sale',
        component: ProductKeywordMappingComponent,
        pathMatch: 'full',
    },
    {
        path: 'products/:keyword',
        component: ProductKeywordMappingComponent,
        pathMatch: 'full',
    },

    {
        path: 'products/:department',
        component: CategoriesComponent,
        pathMatch: 'full',
    },
    {
        path: 'shop/products/:department/:category',
        component: CategoriesComponent,
        pathMatch: 'full',
    },
    {
        path: 'products/:department/:category',
        component: ProductsComponent,
        pathMatch: 'full',
    }, {
        path: 'products/:department/:category/:subCategory',
        component: ProductsComponent,
        pathMatch: 'full',
    },
    {
        path: 'product/:product/preview',
        loadChildren: () =>
            import(
                './feature/containers/product-details/product-details.module'
            ).then((m) => m.ProductDetailsModule),
        pathMatch: 'full',
    },
    {
        path: 'product/:product',
        loadChildren: () =>
            import(
                './feature/containers/product-details/product-details.module'
            ).then((m) => m.ProductDetailsModule),
        pathMatch: 'full',
    },
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,
        pathMatch: 'full',
    },
    {
        path: 'reset-password',
        component: ResetPasswordComponent,
        pathMatch: 'full',
    },
    {
        path: 'faq',
        loadChildren: () =>
            import('./feature/faq/faq.module').then((m) => m.FaqModule),
    },
    {
        path: 'furniture-care',
        loadChildren: () =>
            import('./feature/furniture-care/furniture-care.module').then(
                (m) => m.FurnitureCareModule
            ),
    },

    {
        path: 'design/designer/products/all',
        component: ProductCatalogComponent,
    },
    {
        path: 'design/designer/products/favorites',
        component: FavoritesComponent,
    },
      {
        path: 'favorites',
        component: CustomerFavoritesComponent,
    },
    {
        path: 'design/designer',
        loadChildren: () =>
            import('./modules/seller/seller.module').then((m) => m.SellerModule),
        canActivate: [SellerGuard],
    },
    {
        path: 'admin/dashboard',
        component: AdminDashboardComponent,
        canActivate: [AdminGuard],

    },
    {
        path: 'admin/dashboard/mailing-list',
        component: MailListingComponent,
        canActivate: [AdminGuard]


    },
    {
        path: 'admin/dashboard/partners',
        component: PartnersComponent,
        canActivate: [AdminGuard]


    },
    {
        path: 'admin/dashboard/design-contact-log',
        component: DesignContactLogComponent,
        canActivate: [AdminGuard]


    },
    {
        path: 'admin/dashboard/add-product',
        component: AdminAddProductComponent,
        canActivate: [AdminGuard]


    },
    {
        path: 'admin/dashboard/cb-inventory',
        component: CbInventoryComponent,
        canActivate: [AdminGuard]


    },
    {
        path: 'admin/dashboard/design/rooms',
        component: DesignDashboardComponent,
        canActivate: [AdminGuard],

    },
    {
        path: 'admin/dashboard/reporting',
        loadChildren: () =>
            import(
                './modules/reporting/reporting.module'
            ).then((m) => m.ReportingModule),
        canActivate: [AdminGuard],
    },
    {
        path: 'admin/dashboard/new-products',
        loadChildren: () =>
            import(
                './modules/new-products-dashboard/new-products-dashboard.module'
            ).then((m) => m.NewProductsDashboardModule),
        canActivate: [AdminGuard],
    },
    {
        path: 'admin/dashboard/edit-products',
        loadChildren: () =>
            import(
                './modules/new-products-dashboard/edit-products-dashboard.module'
            ).then((m) => m.EditProductsDashboardModule),
        canActivate: [AdminGuard],
    },
    {
        path: 'admin/dashboard/orders',
        loadChildren: () =>
            import(
                './modules/order-list/order-list.module'
            ).then((m) => m.OrderListModule),
        canActivate: [AdminGuard],
    },
    {
        path: 'admin/dashboard/collections',
        loadChildren: () =>
            import(
                './modules/collections-dashboard/collections-dashboard.module'
            ).then((m) => m.CollectionsDashboardModule),
        canActivate: [AdminGuard]
    },
    {
        path: 'admin-dashboard',
        loadChildren: () =>
            import('./modules/admin-dashboard/admin-dashboard.module').then(
                (m) => m.AdminDashboardModule
            ),
        canActivate: [AdminGuard]
    },
    {
        path: 'admin/dashboard/merchandising',
        loadChildren: () =>
            import('./modules/dashboards/dashboards.module').then(
                (m) => m.DashboardsModule
            ),
        canActivate: [AdminGuard]
    },
    { path: 'settings/profile', component: EditMyProfileComponent },
    { path: 'p/:profile', component: PublicProfileComponent },
    { path: 'product/review/:product', component: ReviewFormMobileComponent },
    {
        path: 'product/view-reviews/:product',
        component: AllReviewsMobileComponent,
    },
    {
        path: 'order-details',
        loadChildren: () =>
            import('./feature/containers/order-details/order-details.module').then(
                (m) => m.OrderDetailsModule
            ),
    },
    {
        path: 'product/quiz',
        component: QuizDesktopComponent,
        // canDeactivate:[SellerGuard]
    },
    {
        path: 'style-quiz',
        component: OnboardQuizDesktopComponent,
    },
    {
        path: 'style-quiz/my-style/:styleId',
        component: OnboardQuizDesktopComponent,
    },
    {
        path: 'product/quiz-result',
        component: ResultPageComponent
    },

    {
        path: '**',
        component: LandingComponent,
        pathMatch: 'full',
        redirectTo: ''
        // canActivate: [AdminGuard]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}